import { IconProps, NocIconGenerator } from '../common';

export const ArrowUp3 = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'ArrowUp3',
            path: (
                <path
                    d="M12 9.65L3.19 18.9L1.04 16.75L12 5.25L22.96 16.75L20.81 18.9L12 9.65Z"
                    fill="currentColor"
                />
            ),
        }}
    />
);
